__turbopack_context__.v({
  "author": "tweet-header-module__A9EVQG__author",
  "authorFollow": "tweet-header-module__A9EVQG__authorFollow",
  "authorLink": "tweet-header-module__A9EVQG__authorLink",
  "authorLinkText": "tweet-header-module__A9EVQG__authorLinkText",
  "authorMeta": "tweet-header-module__A9EVQG__authorMeta",
  "authorVerified": "tweet-header-module__A9EVQG__authorVerified",
  "avatar": "tweet-header-module__A9EVQG__avatar",
  "avatarOverflow": "tweet-header-module__A9EVQG__avatarOverflow",
  "avatarShadow": "tweet-header-module__A9EVQG__avatarShadow",
  "avatarSquare": "tweet-header-module__A9EVQG__avatarSquare",
  "brand": "tweet-header-module__A9EVQG__brand",
  "follow": "tweet-header-module__A9EVQG__follow",
  "header": "tweet-header-module__A9EVQG__header",
  "separator": "tweet-header-module__A9EVQG__separator",
  "twitterIcon": "tweet-header-module__A9EVQG__twitterIcon",
  "username": "tweet-header-module__A9EVQG__username",
});
